/* ============================================================
   Rossi Morreti — theme behaviour
   Header scroll, overlays, menu, cart drawer (AJAX), PDP gallery,
   variant selection, welcome/notify modal.
   ============================================================ */
(function () {
  'use strict';

  var RM = window.RM || {};
  RM.routes = RM.routes || {};

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function lockScroll(on) {
    document.body.classList.toggle('rm-no-scroll', !!on);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = RM.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- header scroll ---------- */
  var header = $('[data-rm-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 100);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- overlays (menu / search / cart / modal) ---------- */
  function overlayEl(name) {
    if (name === 'cart') return $('[data-rm-cart-root]');
    return $('[data-rm-overlay="' + name + '"]');
  }

  function openOverlay(name) {
    var el = overlayEl(name);
    if (!el) return;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    if (name === 'cart') {
      var back = $('[data-rm-cart-back]');
      if (back) back.classList.add('open');
    }
    lockScroll(true);
    if (name === 'search') {
      var input = $('[data-rm-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 200);
    }
  }

  function closeOverlay(name) {
    var el = overlayEl(name);
    if (el) {
      el.classList.remove('open');
      el.setAttribute('aria-hidden', 'true');
    }
    if (name === 'cart') {
      var back = $('[data-rm-cart-back]');
      if (back) back.classList.remove('open');
    }
    // only release scroll if nothing else is open
    var anyOpen = $('.rm-menu.open') || $('.rm-search.open') ||
                  $('.rm-cart.open') || $('.rm-modal-back.open');
    if (!anyOpen) lockScroll(false);
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-rm-open]');
    if (openTrigger) {
      e.preventDefault();
      openOverlay(openTrigger.getAttribute('data-rm-open'));
      return;
    }
    var closeTrigger = e.target.closest('[data-rm-close]');
    if (closeTrigger) {
      e.preventDefault();
      closeOverlay(closeTrigger.getAttribute('data-rm-close'));
      return;
    }
    // click cart backdrop
    if (e.target.matches('[data-rm-cart-back]')) {
      closeOverlay('cart');
      return;
    }
    // click modal backdrop
    if (e.target.matches('[data-rm-overlay="modal"]')) {
      closeOverlay('modal');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      ['menu', 'search', 'cart', 'modal'].forEach(closeOverlay);
    }
  });

  /* ---------- menu submenu expansion ---------- */
  var subColumn = $('[data-rm-sub-column]');
  var menuItems = $('[data-rm-menu-items]');

  function showSubPanel(index) {
    $all('[data-rm-sub-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-rm-sub-panel') !== String(index);
    });
    $all('[data-rm-submenu]').forEach(function (it) {
      it.classList.toggle('is-active', it.getAttribute('data-rm-submenu') === String(index));
    });
    if (subColumn) subColumn.classList.add('open');
  }

  function hideSubPanels() {
    $all('[data-rm-sub-panel]').forEach(function (p) { p.hidden = true; });
    $all('[data-rm-submenu]').forEach(function (it) { it.classList.remove('is-active'); });
    if (subColumn) subColumn.classList.remove('open');
  }

  var isMobileMenu = function () {
    return window.matchMedia('(max-width: 900px)').matches;
  };

  if (menuItems) {
    $all('[data-rm-submenu]').forEach(function (item) {
      var index = item.getAttribute('data-rm-submenu');
      item.addEventListener('mouseenter', function () {
        if (!isMobileMenu()) showSubPanel(index);
      });
      item.addEventListener('click', function () {
        if (isMobileMenu()) {
          var m = $('[data-rm-submenu-mobile="' + index + '"]');
          if (m) m.classList.toggle('open');
        }
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });
    menuItems.addEventListener('mouseleave', function () {
      if (!isMobileMenu()) hideSubPanels();
    });
  }

  /* ---------- cart drawer (AJAX) ---------- */
function refreshCartDrawer(openAfter){
      return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var wrapper = document.getElementById('shopify-section-cart-drawer');
        if (wrapper) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#shopify-section-cart-drawer') || tmp.firstElementChild;
          if (fresh) wrapper.innerHTML = fresh.innerHTML;
        }
        if (openAfter) {
          openOverlay('cart');
        }
      })
      .catch(function () { /* network hiccup — leave drawer as-is */ });
  }

  function updateCartCounts(count) {
    $all('[data-rm-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  // qty + / - / remove (delegated, survives re-render)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rm-qty]');
    if (!btn) return;
    var row = btn.closest('[data-rm-cart-item]');
    if (!row) return;
    var line = row.getAttribute('data-line');
    var action = btn.getAttribute('data-rm-qty');
    var current = parseInt(row.querySelector('.rm-cart__qty span').textContent, 10) || 1;
    var target = current;
    if (action === 'plus') target = current + 1;
    else if (action === 'minus') target = Math.max(0, current - 1);
    else if (action === 'remove') target = 0;

    fetch(RM.routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: target })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCounts(cart.item_count);
        refreshCartDrawer(false);
      });
  });

  /* ---------- product page ---------- */
  var productRoot = $('[data-rm-product]');
  if (productRoot) {
    var productData = {};
    try {
      var json = $('[data-rm-product-json]');
      if (json) productData = JSON.parse(json.textContent);
    } catch (err) { productData = {}; }

    /* gallery */
    var gallery = $('[data-rm-gallery]');
    if (gallery) {
      var slides = $all('[data-rm-slide]', gallery);
      var thumbs = $all('[data-rm-thumb]');
      var current = 0;

      var goTo = function (i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('active', idx === current); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === current); });
      };

      var prev = $('[data-rm-gallery-prev]');
      var next = $('[data-rm-gallery-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.getAttribute('data-rm-thumb'), 10));
        });
      });
    }

    /* variant pills */
    var variantInput = $('[data-rm-variant-id]');
    var addBtn = $('[data-rm-add-to-cart]');
    var priceEls = $all('[data-rm-price]');

    function selectVariant(id) {
      var variant = (productData.variants || []).filter(function (v) {
        return String(v.id) === String(id);
      })[0];
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      $all('[data-rm-pill]').forEach(function (p) {
        p.classList.toggle('active', String(p.getAttribute('data-variant-id')) === String(id));
      });
      priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      if (addBtn) {
        addBtn.textContent = variant.available
          ? (RM.strings.addToCart || 'Add to Cart')
          : (RM.strings.notifyMe || 'Notify Me');
      }
    }

    $all('[data-rm-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.getAttribute('data-available') === 'true') {
          selectVariant(pill.getAttribute('data-variant-id'));
        } else {
          // sold-out size — open notify modal
          openNotify(productData.title);
        }
      });
    });

    /* add to cart */
    function addToCart() {
      var id = variantInput ? variantInput.value : null;
      if (!id) return;
      var variant = (productData.variants || []).filter(function (v) {
        return String(v.id) === String(id);
      })[0];

      if (variant && !variant.available) {
        openNotify(productData.title);
        return;
      }

      fetch(RM.routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            // error (e.g. out of stock)
            openNotify(productData.title);
            return;
          }
          return fetch(RM.routes.cart_url || '/cart', {
            headers: { 'Accept': 'application/json' }
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateCartCounts(cart.item_count);
              refreshCartDrawer(true);
            });
        });
    }

    var form = $('[data-rm-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart();
      });
    }
    var mobileBtn = $('[data-rm-add-to-cart-mobile]');
    if (mobileBtn) mobileBtn.addEventListener('click', addToCart);
  }

  /* ---------- welcome / notify modal ---------- */
  function showModalView(view) {
    $all('[data-rm-modal-view]').forEach(function (v) {
      v.hidden = v.getAttribute('data-rm-modal-view') !== view;
    });
  }

  function openWelcome() {
    showModalView('welcome');
    openOverlay('modal');
  }

  function openNotify(productName) {
    showModalView('notify');
    var text = $('[data-rm-notify-text]');
    var note = $('[data-rm-notify-note]');
    if (text) text.textContent = productName
      ? productName + ' — restock alert.'
      : 'Restock alert.';
    if (note) note.value = productName ? ('Restock request: ' + productName) : 'Restock request';
    openOverlay('modal');
  }
  window.rmOpenNotify = openNotify;

  // if a modal form just posted successfully, show the "done" view
  if (RM.modalPosted) {
    showModalView('done');
    openOverlay('modal');
  }

  // welcome popup — 12s after first visit, suppressed for the session
  if (!sessionStorage.getItem('rm_welcomed')) {
    setTimeout(function () {
      if (sessionStorage.getItem('rm_welcomed')) return;
      sessionStorage.setItem('rm_welcomed', '1');
      // don't interrupt if another overlay is already open
      var anyOpen = $('.rm-menu.open') || $('.rm-search.open') ||
                    $('.rm-cart.open') || $('.rm-modal-back.open');
      if (!anyOpen) openWelcome();
    }, 12000);
  }
})();
